export default __webpack_public_path__ + "static/media/icon_tabs_skills_active.ca2ee3bc.svg";